import {AllHtmlEntities} from 'html-entities';

const entities = new AllHtmlEntities();

export const escape = (input: string | undefined | null) => {
  return input ? entities.encode(input) : input;
};
